import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "~/material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "~/material-dashboard/components/Grid/GridItem.jsx";
import Button from "~/material-dashboard/components/CustomButtons/Button.jsx";
import Card from "~/material-dashboard/components/Card/Card.jsx";
import CardBody from "~/material-dashboard/components/Card/CardBody.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import imgChocoChillMint from "~assets/images/flavors/choco-chill.png";
import imgCitrusZen from "~assets/images/flavors/citrus-zen.png";

import {
  getVisitProduct,
  setVisitProduct,
  setOrderItemSubcategory,
  getOrderItemSubcategory,
  getVisitID,
  isFollowUpVisit,
  setConsultationTypeOrderItem,
  getVisitUSState,
} from "~/visits/utils/visitCookies";

import {
  ORDER_TYPE_ATE_SCO_1_PACK,
  ORDER_TYPE_ATE_SCO_1_PACK_FOLLOW_UP,
  ORDER_TYPE_ATE_SCO_1_PACK_REFILL,
  ORDER_TYPE_ATE_SCO_2_PACK,
  ORDER_TYPE_ATE_SCO_2_PACK_FOLLOW_UP,
  ORDER_TYPE_ATE_SCO_2_PACK_REFILL,
  CHOCO_CHILL_MINT_FLAVOR,
  CITRUS_ZEN_FLAVOR,
  PRICE_ATE_SCO_1_PACK,
  PRICE_ATE_SCO_1_PACK_FOLLOW_UP,
  PRICE_ATE_SCO_1_PACK_REFILL,
  PRICE_ATE_SCO_2_PACK,
  PRICE_ATE_SCO_2_PACK_FOLLOW_UP,
  PRICE_ATE_SCO_2_PACK_REFILL,
} from "~/shared/sharedConstants.js";

import { supportedUSStatesForCompoundedMeds } from "~/shared/utils/sharedUtils";

import { kickBlue } from "~/shared/styles/baseStyles";

const flavors = [
  {
    name: "Choco Chill Mint",
    image: imgChocoChillMint,
    flavorConst: CHOCO_CHILL_MINT_FLAVOR,
    longDescription:
      "Smooth chocolate meets refreshing mint in a fast-acting lozenge. Indulgent calmness when you need it most.",
  },
  {
    name: "Citrus Zen",
    image: imgCitrusZen,
    longDescription:
      "Bright citrus notes with a hint of lemon in a fast-acting lozenge. Find your zen with this refreshing flavor.",
    flavorConst: CITRUS_ZEN_FLAVOR,
  },
];

const SelectGAFlavored = ({ classes, history, match }) => {
  const consultationType = match.params.consultationType;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const checkoutSessionID = queryParams.get("checkoutSessionID");
  if (!checkoutSessionID) {
    window.location.href = "/me/portal";
  }

  const [selectedFlavor, setSelectedFlavor] = useState(
    getOrderItemSubcategory(consultationType, checkoutSessionID) || null
  );
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!getVisitID(checkoutSessionID)) {
      window.location.href = "/me/portal";
      return;
    }

    const visitIDCheckPoller = setInterval(() => {
      if (!getVisitID(checkoutSessionID)) {
        window.location.href = "/me/portal";
      }
    }, 1000);

    if (!supportedUSStatesForCompoundedMeds.includes(getVisitUSState())) {
      history.replace(
        `/visits/${consultationType}/payment/order-details?checkoutSessionID=${checkoutSessionID}`
      );
    }

    return () => clearInterval(visitIDCheckPoller);
  }, []);

  const handleSelection = (selectedFlavor) => {
    setSelectedFlavor(selectedFlavor);
    setShowError(false);
  };

  const setVisitProductAndOrderItem = (productSlug) => {
    setVisitProduct(productSlug, checkoutSessionID);
    setConsultationTypeOrderItem(
      consultationType,
      productSlug,
      checkoutSessionID
    );
  };

  const nextQuestion = () => {
    if (selectedFlavor === null) {
      setShowError(true);
      return;
    }

    const currentProduct = getVisitProduct(checkoutSessionID);
    const isTwoPack = currentProduct.includes("2-pack");

    // Set the appropriate GA product based on pack size and visit type
    if (isFollowUpVisit(checkoutSessionID)) {
      // For follow-up visits, use refill pricing
      const isRefill = currentProduct.includes("refill");
      if (isRefill) {
        setVisitProductAndOrderItem(
          isTwoPack
            ? ORDER_TYPE_ATE_SCO_2_PACK_REFILL
            : ORDER_TYPE_ATE_SCO_1_PACK_REFILL
        );
      } else {
        setVisitProductAndOrderItem(
          isTwoPack
            ? ORDER_TYPE_ATE_SCO_2_PACK_FOLLOW_UP
            : ORDER_TYPE_ATE_SCO_1_PACK_FOLLOW_UP
        );
      }
    } else {
      setVisitProductAndOrderItem(
        isTwoPack ? ORDER_TYPE_ATE_SCO_2_PACK : ORDER_TYPE_ATE_SCO_1_PACK
      );
    }

    // Set the selected flavor
    setOrderItemSubcategory(
      consultationType,
      selectedFlavor,
      checkoutSessionID
    );

    // Navigate to payment
    history.push(
      `/visits/${consultationType}/payment/order-details?checkoutSessionID=${checkoutSessionID}`
    );
    window.scrollTo(0, 0);
  };

  const isSelected = (flavorConst) => {
    return selectedFlavor === flavorConst;
  };

  return (
    <div className={classes.container} style={{ backgroundColor: "#3F3F82" }}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={10} md={6}>
          <h3
            style={{
              color: "#FFFFFF",
              fontFamily: "Spectral-SemiBold",
              fontSize: "32px",
              marginTop: "40px",
            }}
          >
            Choose Your Flavor
          </h3>
          <p
            style={{
              color: "#FFFFFF",
              fontFamily: "BasisGrotesquePro-Regular",
              fontSize: "18px",
              lineHeight: "26px",
            }}
          >
            Our specially formulated Atenolol + Scopolamine combination comes in
            two delicious flavors. These fast-acting lozenges dissolve quickly
            for rapid relief when you need it most.
            <br />
            <br />
          </p>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}></GridItem>
        <GridItem xs={12} sm={10} md={6}>
          <Card
            className={classes.cardConsultation}
            style={{ paddingTop: "20px", paddingBottom: "20px" }}
          >
            <CardBody
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2px",
              }}
            >
              {flavors.map((flavor, idx) => {
                return (
                  <div key={flavor.flavorConst}>
                    <div
                      className={classes.selectFlavoredProductWrapper}
                      style={{
                        overflow: "hidden",
                        backgroundColor: isSelected(flavor.flavorConst)
                          ? "#fff7e5"
                          : "",
                      }}
                      onClick={() => handleSelection(flavor.flavorConst)}
                    >
                      <img
                        src={flavor.image}
                        style={{
                          position: "relative",
                          width: "200px",
                          height: "200px",
                        }}
                        alt={`${flavor.name} Flavor`}
                      />
                      <div className={classes.selectFlavorImageTitleWrapper}>
                        <h4
                          className={classes.selectFlavorImageTitle}
                          style={{
                            color: kickBlue,
                            fontWeight: "bold",
                          }}
                        >
                          {flavor.name}
                        </h4>
                        <p
                          style={{
                            marginTop: "4px",
                            marginBottom: "8px",
                            fontSize: "16px",
                          }}
                        >
                          {flavor.longDescription}
                        </p>
                      </div>
                    </div>
                    {idx !== flavors.length - 1 && (
                      <div
                        style={{
                          height: "1px",
                          margin: "0 25%",
                          backgroundColor: "#aaa",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </CardBody>
          </Card>
          <div style={{ color: "red", margin: "20px auto 6px auto" }}>
            <p style={{ textAlign: "center" }}>
              {showError ? "Please select a flavor to continue" : ""}
            </p>
          </div>
          <Button
            onClick={() => {
              nextQuestion();
            }}
            style={{
              display: "block",
              backgroundColor: "#F25930",
              margin: "16px auto",
              width: "300px",
              fontSize: "18px",
              fontWeight: "medium",
              textTransform: "unset",
            }}
          >
            Continue
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(SelectGAFlavored);
